import makeStyles from '@mui/styles/makeStyles';
import { green, lightBlue, red } from '@mui/material/colors';

export default makeStyles(theme => ({
    content: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
    },
    dropZone: {
        borderStyle: 'dashed',
        borderWidth: 4,
        borderColor: '#ccc',
        borderRadius: 8,

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',

        cursor: 'pointer',

        flex: 1,
        minHeight: 256,
    },
    fileList: {
        minWidth: 384,
        overflowY: 'auto',
        marginLeft: 8,
    },

    file_uploading: {
        backgroundColor: lightBlue[100],
    },
    file_error: {
        backgroundColor: red[100],
    },
    file_uploaded: {
        backgroundColor: green[100],
    },

    filePreview: {
        marginRight: 8,
    },
}));